<template>
    <div class="row">
        <div class="col-lg-2 col-md-3 col-sm-4 col-5" v-if="baseInfo != null">
            <div class="logo-area default">
                <router-link to="/">
                    <img :src="baseInfo.LogoPicPath" :title="baseInfo.ShopName" :alt="baseInfo.ShopName" />
                </router-link>
            </div>
        </div>
        <div class="col-lg-4 col-md-5 col-sm-8 col-7">
            <div class="flex h-100">
                <search-box></search-box>
            </div>
      
        </div>
        <div class="col-md-6 col-sm-12 ">
            <div class="flex h-100">
                <div class="user-login dropdown" v-if="!isUserLogined">
                    <a href="#" title="ورود / ثبت نام" class="btn btn-neutral dropdown-toggle" data-toggle="dropdown"
                       id="navbarDropdownMenuLink1">
                        ورود / ثبت نام
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink1">
                        <div class="dropdown-item">
                            <router-link to="/login" title="ورود به سیستم" class="btn btn-info">ورود به سیستم</router-link>
                        </div>
                        <div class="dropdown-item font-weight-bold">
                            <span>کاربر جدید هستید؟</span> <router-link to="/register" title="ثبت نام" class="register">ثبت‌نام</router-link>
                        </div>
                    </ul>
                </div>
                <div class="user-login dropdown" v-else>
                    <a href="#" class="btn btn-neutral dropdown-toggle" data-toggle="dropdown"
                       id="navbarDropdownMenuLink1">
                        {{ userFullName }}
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink1">
                        <li class="dropdown-item order">
                            <i class="now-ui-icons shopping_bag-16"></i>
                            <router-link class="all-width" to="/info" title="پروفایل من" tag="a">پروفایل من</router-link>
                        </li>
                        <li><hr /></li>
                        <li class="dropdown-item font-weight-bold signOut">
                            <i class="now-ui-icons media-1_button-power"></i>
                            <a class="all-width" title="خروج از حساب کاربری" @click="signout">خروج از حساب کاربری</a>
                        </li>
                    </ul>

                    <!--<span v-if="customerGroupId == 2" class="spn-panel">پنل همکاری</span>-->
                </div>
                <header-cart></header-cart>
            </div>
          
        </div>
    </div>
</template>

<script>
    import headerCart from "./headerCart.vue";
    import searchBox from "./searchBox.vue" 
    export default {
        data() {
            return {
                isUserLogined: false,
            }
        },
        components: {
            'header-cart': headerCart, 
            'search-box': searchBox 
        },
        computed: {
            userFullName: function () {
                return this.$store.getters.readUserFullName;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            },
            customerGroupId: function () {
                return this.$store.getters.readCustomerGroupId;
            },
        },
        methods: {
            signout() {
                localStorage.removeItem('accessToken');
                localStorage.removeItem('CartHashId');
                this.$store.commit('setUserFullName', '');
                this.isUserLogined = false;
                window.location.href = "/";
            },
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        }
    }
</script>

<style scoped>
    .spn-panel {
        background-color: #dcbd91;
        display: inline-block;
        margin-top: 5px;
        color: #333;
        padding: 1px 12px 5px 12px;
        border-radius: 7px;
        font-size: 14px;
        line-height: 1.9;
    }
    .all-width {
        display: inline-block;
        width: 75%;
    }
    .order .shopping_bag-16, .signOut .media-1_button-power {
        text-align: right !important;
        font-size: 18px !important;
        color: #333 !important;
        opacity: .6 !important;
        padding-left: 10px;
        padding-right: 15px;
        vertical-align: middle;
    }

    .order, .signOut {
        text-align: right !important;
    }

    .user-login ul li {
        cursor: pointer;
    }

   
</style>